export default [
	'$timeout',
	function ($timeout) {
		return {
			restrict: 'A',
			link: function ($scope, $elem) {
				$scope.$watch('showErrorMessage', function () {
					$timeout(function () {
						$elem[0].focus();
					}, 500);
				});
			}
		};
	}
];
